module.exports = {
    landing: {
        warranty: '24 meses de garantía'
    }
}